import _prop from "ramda/es/prop";
import _head from "ramda/es/head";
import _compose from "ramda/es/compose";

var awsEvent = function (service) {
  return _compose(_prop(service), _head, _prop('Records'));
};

export default awsEvent;